import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { DIC } from '../../../dic';
import { GN } from '../../../../gn';

/**
 * Generated class for the EditindoorpausetypePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-editindoorpausetypes',
  templateUrl: 'editindoorpausetypes.html',
})
export class EditindoorpausetypesPage {
  cb: any
  id = -1
  name = ''

  constructor(public navCtrl: NavController, public navParams: NavParams, public dic: DIC, public gn: GN) {
    this.id = this.navParams.get('id')
    this.name = navParams.get('name')
    this.cb = navParams.get('cb')
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad EditindoorpausetypesPage');
  }

  doSave(_id, _name, _op) {
    var _that = this
    var _dat = {
      cid: this.gn.crypt(this.gn.user.ClientId),
      id: this.gn.crypt(_id),
      name: this.gn.crypt(_name),
      op: this.gn.crypt(_op),
      type: this.gn.crypt('PauseTypes')
    }
    this.gn._Post('/api/gn/addcolutures', _dat, function (_data) {
      _that.cb()
      _that.navCtrl.pop()
    })
  }

}



// WEBPACK FOOTER //
// ./src/pages/settings/indoorpausetypes/editindoorpausetypes/editindoorpausetypes.ts